import React, { useEffect } from 'react';
import moment from 'moment';
import trLocale from 'date-fns/locale/tr';
import enLocale from 'date-fns/locale/en-GB';
import ruLocale from 'date-fns/locale/ru';
import arLocale from 'date-fns/locale/ar';
import { useTranslation } from 'react-i18next';

import { TextField, InputAdornment, Popover, Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DateRangeIcon from '@mui/icons-material/DateRange';
import 'react-date-range/dist/styles.css'; // mai   n style file
import 'react-date-range/dist/theme/default.css';

import { DateRange } from 'react-date-range';

export const SCUIDateRanger = (props: any) => {
    const [lang, setLang] = React.useState(trLocale);
    const dateFormat = 'DD/MM/YYYY';
    const { t, i18n } = useTranslation();
    useEffect(() => {
        let lang = i18n.language;
        if (lang === 'en-US') setLang(enLocale);
        if (lang === 'ar-AR') setLang(arLocale);
        if (lang === 'ru-RU') setLang(ruLocale);
        if (lang === 'tr-TR') setLang(trLocale);
    }, [i18n.language]);

    const [state, setState] = React.useState({
        displayCalendar: false,
        inputValue: props.fromDate ? props.fromDate + ' - ' + props.toDate : '',
        anchorEl: null,
        fromDate: props.fromDate ? moment(props.fromDate, props.dateFormat).toDate() : new Date(),
        toDate: props.toDate ? moment(props.toDate, props.dateFormat).toDate() : new Date(),
    });
    const onAdornmentClick = (e: any) => {
        setState({ ...state, displayCalendar: true, anchorEl: e.currentTarget });
    };

    const processInputValue = (value: any) => {
        let [fromDate, toDate] = (value || '').split('-').map((elm: any) => elm.trim());

        fromDate = moment(fromDate, dateFormat);
        fromDate = fromDate.isValid() ? fromDate.toDate() : undefined;
        toDate = moment(toDate, dateFormat);
        toDate = toDate.isValid() ? toDate.toDate() : undefined;
        return { fromDate, toDate };
    };
    const onInputChange = (e: any) => {
        const inputValue = e.target.value;
        const { fromDate, toDate } = processInputValue(inputValue);
        props.setDateRange([!fromDate && '', !toDate && '']);

        setState({
            ...state,
            inputValue: inputValue,
            fromDate: fromDate,
            toDate: toDate,
        });
    };
    const onPopoverClose = () => {
        setState({ ...state, displayCalendar: false, anchorEl: null });
    };

    const onSelectDateRanges = (item: any) => {
        let startDate = item.selection.startDate;
        let endDate = item.selection.endDate;
        startDate = moment(startDate);
        startDate = startDate.isValid() ? startDate.toDate() : undefined;
        endDate = moment(endDate);
        endDate = endDate.isValid() ? endDate.toDate() : undefined;
        let inputValue = '';
        if (startDate) inputValue += moment(startDate).format(dateFormat);
        if (endDate) inputValue += ' - ' + moment(endDate).format(dateFormat);

        props.setDateRange([moment(startDate).format(props.dateFormat), moment(endDate).format(props.dateFormat)]);

        setState({
            ...state,
            fromDate: startDate,
            toDate: endDate,
            inputValue: inputValue,
        });
    };

    return (
        <>
            <Box sx={props.containerStyling || {}}>
                <TextField
                    label={props.label ? props.label : t('general.dateRange')}
                    fullWidth={true}
                    variant={'outlined'}
                    value={state.inputValue}
                    size={props.size ? props.size : 'medium'}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={onAdornmentClick}>
                                        <DateRangeIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            style: {
                                borderRadius: props.borderRadius ? props.borderRadius : '',
                            },
                        },
                    }}
                    onChange={onInputChange}
                />
                <Popover
                    open={state.displayCalendar}
                    anchorEl={state.anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    onClose={onPopoverClose}
                >
                    <DateRange
                        locale={lang}
                        ranges={[
                            {
                                startDate: state.fromDate,
                                endDate: state.toDate,
                                key: 'selection',
                            },
                        ]}
                        onChange={onSelectDateRanges}
                        showMonthAndYearPickers={true}
                        moveRangeOnFirstSelection={false}
                        showDateDisplay={true}
                        scroll={{ enabled: true }}
                        //showSelectionPreview={true}
                    />
                </Popover>
            </Box>
        </>
    );
};
